'use strict';
{
    var app = angular.module('tf.portfolio.widgets.raSecurity', [])
        .controller('raSecurityCtrl', ['$scope', '$timeout', function portfolioController($scope, $timeout) {

            $scope.widgetContentHeight = 250;

            $scope.$on('gridster-resized', function() {
                $scope.updateChartHeight();
            });

            $scope.$on('gridster-item-resized-stop', function(widget) {
                $scope.updateChartHeight();
            });

            $scope.$watch('gridsterItem.sizeY', function() {
                $scope.updateChartHeight();
            });

            $scope.updateChartHeight = function() {
                $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
                $scope.raSecurityOptions.chart.height = $scope.widgetContentHeight;
                if ($scope.chartApi) {
                    $scope.chartApi.refresh();
                }
            };

            var percent = {style: 'percent', maximumFractionDigits: 0};
            var indexFormat = d3.format('0.0f');
            var etoFormat = d3.format('$,.3f');


            $scope.raDataSecurity = [];

            $scope.summaryChart = {
                data: [],
                type: 'summary'
            };

            $scope.activeChart = $scope.summaryChart;
            $scope.securityCharts = [];
            $scope.securityChartsByUnderlying = {};

            var legendState = {};

            $scope.raSecurityOptions = {
                chart: {
                    type: 'lineChart',
                    height: $scope.widgetContentHeight,
                    margin : {
                        top: 50,
                        right: 20,
                        bottom: 50,
                        left: 60
                    },
                    lines: {
                        dispatch: {
                            elementClick: function (event) {
                                $scope.showChart(event.series.securityChart || $scope.summaryChart);
                            }
                        }
                    },
                    legend : {
                        dispatch : {
                            legendClick : function (event, index) {
                                if (event.security) {
                                    if (legendState[event.security]) {
                                        legendState[event.security] = !legendState[event.security];
                                    } else {
                                        legendState[event.security] = true;
                                    }

                                    if (index % 2 == 1) {
                                        $scope.raDataSecurity[index - 1].disabled = legendState[event.security];
                                    } else {
                                        $scope.raDataSecurity[index + 1].disabled = legendState[event.security];
                                    }
                                }
                            }

                        }
                    },
                    duration: 1000,
                    interpolate: 'monotone',
                    clipVoronoi: true,
                    x: function(d){ return d[0]; },
                    y: function(d){ return d[1]; },
                    useInteractiveGuideline : false,
                    tooltip: {
                        contentGenerator: function (e) {

                            var tooltip = '<h3>';
                            var key = e.series[0].key;
                            if ($scope.activeChart !== $scope.summaryChart) {
                                switch (e.seriesIndex) {
                                    case 0:
                                    case 1:
                                        var vsr = null;
                                        var ccData = e.series[0].cc;

                                        if (ccData.vsr.scanAmount) {
                                            vsr = '' + ccData.vsr.scanAmount;
                                        } else {
                                            vsr = ccData.vsr.scanPct.toLocaleString(undefined, percent);
                                        }
                                        tooltip += key + ' ' + vsr;
                                        break;
                                    case 2:
                                        tooltip += key;
                                        break;
                                }
                            } else {
                                var ccData = e.series[0].cc;

                                if (ccData.vsr.scanAmount) {
                                    vsr = '' + ccData.vsr.scanAmount;
                                } else {
                                    vsr = ccData.vsr.scanPct.toLocaleString(undefined, percent);
                                }
                                tooltip += key + ' ' + vsr;

                            }

                            tooltip += '</h3>';
                            tooltip += '<table><tbody>';
                            tooltip += '<tr><td class="key">Expected Outcome</td><td class="value">' + $scope.raSecurityOptions.chart.yAxis.tickFormat(e.point[1]) + '</td>';
                            tooltip += '<tr><td class="key">' + ($scope.activeChart !== $scope.summaryChart ? 'Price' : 'XJO') + '</td><td class="value">' + $scope.raSecurityOptions.chart.xAxis.tickFormat(e.point[0]) + '</td>';
                            if (e.point[2]) {
                                tooltip += '<tr><td class="key">Risk Array</td><td class="value">' + e.point[2] + '</td>';
                            }
                            tooltip += '</tbody></table>';
                            return tooltip;
                        }
                    },
                    xAxis: {
                        ticks : 12,
                        axisLabel: 'Underlying Price',
                        tickFormat: function (value) {

                            if ($scope.activeChart !== $scope.summaryChart) {
                                var ccData = $scope.activeChart.cc;

                                var format = $scope.activeChart.underlying == 'XJO' ? indexFormat : etoFormat;

                                if (ccData.psr.scanAmount) {
                                    return format(ccData.price + (ccData.psr.scanAmount * value));
                                } else {
                                    return format(ccData.price + (ccData.price * ccData.psr.scanPct * value));
                                }
                            } else {
                                if ($scope.activeChart.psr.scanAmount) {
                                    return indexFormat($scope.activeChart.price + ($scope.activeChart.psr.scanAmount * value));
                                } else {
                                    return indexFormat($scope.activeChart.price + ($scope.activeChart.price * $scope.activeChart.psr.scanPct * value));
                                }
                            }

                        }
                    },
                    yAxis: {
                        axisLabel: 'Expected Outcome',
                        tickFormat: d3.format('$,.0f'),
                        axisLabelDistance: 30
                    }

                }
            };

            function splitScanArray(scanArray) {
                var volUp = [[-1, scanArray[12], 13], [-0.67, scanArray[8],9 ], [-0.33, scanArray[4], 5], [0, scanArray[0], 1], [0.33, scanArray[2], 3], [0.67, scanArray[6], 7], [1, scanArray[10], 11]];
                var volDown = [[-1, scanArray[13], 14], [-0.67, scanArray[9], 10], [-0.33, scanArray[5], 6], [0, scanArray[1], 2], [0.33, scanArray[3], 4], [0.67, scanArray[7], 8], [1, scanArray[11], 12]];
                var volUnch = [];

                var worstCase = scanArray[0];
                var worstIndex = 0;

                for (var i = 0; i < scanArray.length; i++) {
                    if (scanArray[i] < worstCase) {
                        worstIndex = i;
                        worstCase = scanArray[i];
                    }
                }

                for (var i = 0; i < volUp.length; i++) {
                    volUnch[i] = [volUp[i][0], (volUp[i][1] + volDown[i][1]) / 2.0];

                }

                volUnch.unshift([-2, scanArray[15], 16]);
                volUnch.push([2, scanArray[14], 15]);


                var extreme = worstIndex >= 14;

                return {
                    volDown : volDown,
                    volUnch: volUnch,
                    volUp : volUp,
                    extreme : extreme
                };
            }

            $scope.$on('margin.whatif.changed', function updateData(event, whatIfMargin) {
                var reds = ['#b80000', '#cc0000', '#ff1f1f', '#ff4747', '#ff7070', '#ff9999'];
                var redIndex = 0;

                var ccScanArrays = [];
                var ccPrices = {};

                for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                    var cc = whatIfMargin.combinedCommodities[i];

                    ccPrices[cc.security] = {
                        price : cc.price
                    };
                    var ccScanArray = {
                        underlying : cc.security,
                        scanArray : []
                    };
                    ccScanArrays.push(ccScanArray);
                    for (var j = 0; j < cc.riskArray.length; j++) {
                        ccScanArray.scanArray[j] = -cc.riskArray[j];
                    }

                    ccScanArray.scanArrays = splitScanArray(ccScanArray.scanArray);
                    ccScanArray.price = cc.price;
                    ccScanArray.psr = cc.psr;
                    ccScanArray.vsr = cc.vsr;
                }

                ccScanArrays.sort(function(a, b) {
                    if (a.underlying < b.underlying) {
                        return -1;
                    }
                    if (a.underlying > b.underlying) {
                        return 1;
                    }

                    return 0;
                });

                $scope.summaryChart.psr = whatIfMargin.psr;
                $scope.summaryChart.vsr = whatIfMargin.vsr;
                $scope.summaryChart.price = whatIfMargin.price;
                $scope.summaryChart.data.length = 0;

                for (var i = 0; i < ccScanArrays.length; i++) {
                    var cc = ccScanArrays[i];

                    var ccChart = $scope.securityChartsByUnderlying[cc.underlying];

                    if (ccChart == null) {
                        ccChart = {
                            security : cc.underlying,
                            underlying : cc.underlying,
                            type : 'security',
                            data : []
                        };

                        $scope.securityChartsByUnderlying[cc.underlying] = ccChart;
                        $scope.securityCharts.push(ccChart);
                    }


                    ccChart.psr = cc.psr;
                    ccChart.vsr = cc.vsr;
                    ccChart.price = cc.price;
                    ccChart.cc = cc;
                    ccChart.data = [
                        {
                            key: cc.underlying + " Vol \u25B2",
                            values: cc.scanArrays.volUp,
                            cc : cc
                        },
                        {
                            key: cc.underlying + " Vol \u25BC",
                            values: cc.scanArrays.volDown,
                            cc : cc
                        },
                        {
                            key: cc.underlying + " Vol Unch",
                            values: cc.scanArrays.volUnch,
                            cc : cc
                        }
                    ];

                    var volUp = {
                        key: (cc.scanArrays.extreme ? "*" : "") + cc.underlying + " Vol \u25B2",
                        values: cc.scanArrays.volUp,
                        security: cc.underlying,
                        securityChart : ccChart,
                        cc : cc,
                        disabled: legendState[cc.underlying] || false
                    };

                    var volDown = {
                        key: (cc.scanArrays.extreme ? "*" : "") + cc.underlying + " Vol \u25BC",
                        values: cc.scanArrays.volDown,
                        security: cc.underlying,
                        securityChart : ccChart,
                        cc : cc,
                        disabled: legendState[cc.underlying] || false
                    };


                    $scope.summaryChart.data.push(volUp);
                    $scope.summaryChart.data.push(volDown);

                    if (cc.scanArrays.extreme) {
                        volUp.color = reds[redIndex++];
                        volDown.color = reds[redIndex++];

                        if (redIndex == reds.length) {
                            redIndex = 0;
                        }
                    }
                }

                $timeout(function () {
                    $scope.showChart($scope.activeChart);
                }, 100);

            });

            $scope.showChart = function (chart) {
                $scope.activeChart = chart;

                $scope.raDataSecurity.length = 0;

                chart.data.forEach(function (d) {
                    $scope.raDataSecurity.push(d);
                });


                if ($scope.chartApi) {
                    $scope.chartApi.refresh();
                }

            };

        }]);
}
